var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6387_581",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6387_581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 17C6.5875 17 6.23438 16.8531 5.94062 16.5594C5.64687 16.2656 5.5 15.9125 5.5 15.5V5.5H5.25C5.0375 5.5 4.85938 5.42854 4.71563 5.28563C4.57188 5.14271 4.5 4.96563 4.5 4.75438C4.5 4.54313 4.57188 4.36458 4.71563 4.21875C4.85938 4.07292 5.0375 4 5.25 4H8.5V3.75C8.5 3.5375 8.57188 3.35937 8.71563 3.21562C8.85938 3.07187 9.0375 3 9.25 3H11.75C11.9625 3 12.1406 3.07187 12.2844 3.21562C12.4281 3.35937 12.5 3.5375 12.5 3.75V4H15.75C15.9625 4 16.1406 4.07146 16.2844 4.21437C16.4281 4.35729 16.5 4.53437 16.5 4.74562C16.5 4.95687 16.4281 5.13542 16.2844 5.28125C16.1406 5.42708 15.9625 5.5 15.75 5.5H15.5V15.491C15.5 15.9137 15.3531 16.2708 15.0594 16.5625C14.7656 16.8542 14.4125 17 14 17H7ZM14 5.5H7V15.5H14V5.5ZM9.24563 14C9.45688 14 9.63542 13.9281 9.78125 13.7844C9.92708 13.6406 10 13.4625 10 13.25V7.75C10 7.5375 9.92854 7.35938 9.78562 7.21562C9.64271 7.07187 9.46562 7 9.25437 7C9.04313 7 8.86458 7.07187 8.71875 7.21562C8.57292 7.35938 8.5 7.5375 8.5 7.75V13.25C8.5 13.4625 8.57146 13.6406 8.71438 13.7844C8.85729 13.9281 9.03438 14 9.24563 14ZM11.7456 14C11.9569 14 12.1354 13.9281 12.2812 13.7844C12.4271 13.6406 12.5 13.4625 12.5 13.25V7.75C12.5 7.5375 12.4285 7.35938 12.2856 7.21562C12.1427 7.07187 11.9656 7 11.7544 7C11.5431 7 11.3646 7.07187 11.2188 7.21562C11.0729 7.35938 11 7.5375 11 7.75V13.25C11 13.4625 11.0715 13.6406 11.2144 13.7844C11.3573 13.9281 11.5344 14 11.7456 14Z",
    fill: "#D40000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.53ba4aed0dc2c84bcc5557a0083d4423.svg";
export { ForwardRef as ReactComponent };